/** Strip UTF-8 BOM and trim CSV header names from Papa Parse. */
export function normalizeCsvHeader(header: string): string {
  return header.replace(/^\uFEFF/i, '').trim();
}

export function normalizeCsvHeaders(headers: Array<string>): Array<string> {
  return headers.map(normalizeCsvHeader);
}

/** Re-key parsed rows so column access uses normalized header names. */
export function normalizeCsvRows<T extends Record<string, unknown>>(
  rows: T[],
  rawHeaders: string[],
): T[] {
  const normalized = normalizeCsvHeaders(rawHeaders);
  if (normalized.every((h, i) => h === rawHeaders[i])) {
    return rows;
  }
  return rows.map((row) => {
    const out = {} as Record<string, unknown>;
    rawHeaders.forEach((rawHeader, index) => {
      const key = normalized[index];
      if (!key) return;
      out[key] = row[rawHeader as keyof T];
    });
    return out as T;
  });
}
